import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=1bb4051f&scoped=true"
import script from "./RoleDialog.vue?vue&type=script&lang=js"
export * from "./RoleDialog.vue?vue&type=script&lang=js"
import style0 from "./RoleDialog.vue?vue&type=style&index=0&id=1bb4051f&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb4051f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb4051f')) {
      api.createRecord('1bb4051f', component.options)
    } else {
      api.reload('1bb4051f', component.options)
    }
    module.hot.accept("./RoleDialog.vue?vue&type=template&id=1bb4051f&scoped=true", function () {
      api.rerender('1bb4051f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/systemManagement/components/RoleDialog.vue"
export default component.exports